import { Box, Flex, Image, Link } from "@chakra-ui/react";
import {
  privacyPolicyUrl,
  termsOfServiceUrl,
} from "@verivest/shared-components/src/links/urls";
import React from "react";
import { SectionContainer } from "./general";

const WhiteLabelFooter = () => {
  return (
    <Box boxShadow="inset 0px 1px 0px #E5E5E5" backgroundColor="bg.white">
      <SectionContainer noBorder noPaddingr>
        <Flex py={7} alignItems={"flex-start"}>
          <Flex
            textStyle={"bodySmall"}
            textAlign={"left"}
            color={"text.black"}
            flexGrow={1}
            flexDirection={{ base: "column", md: "row" }}
          >
            &copy; Verivest LLC {new Date().getFullYear()}
            <Box
              as={"span"}
              display={{ base: "none", md: "inline-block" }}
              fontWeight={"bold"}
              px={1.5}
            >
              ·
            </Box>
            <Box>
              <Link
                href={privacyPolicyUrl}
                target={"_blank"}
                color={"text.black"}
                isExternal
              >
                Privacy
              </Link>
              <Box
                as={"span"}
                fontWeight={"bold"}
                px={1.5}
                display={"inline-block"}
              >
                ·
              </Box>
              <Link
                href={termsOfServiceUrl}
                target={"_blank"}
                color={"text.black"}
                isExternal
              >
                Terms
              </Link>
            </Box>
          </Flex>
          <Flex
            alignItems={"center"}
            textStyle={"bodySmall"}
            textAlign={"right"}
            color={"text.black"}
          >
            <Image
              src={"/images/minilogo.svg"}
              fallbackSrc={"/images/minilogo.svg"}
              w={"28px"}
              mr={2}
            />{" "}
            Powered by Verivest{" "}
          </Flex>
        </Flex>
      </SectionContainer>
    </Box>
  );
};

export default WhiteLabelFooter;
